import { useQuery } from '@tanstack/react-query'
import { userTaskSpectatorService } from '../../../../services/users-tasks/users-tasks-spectators'
import { useGetDates } from '../../../date/use-get-dates'
import { useGetMyProfile } from '../../profile/use-get-my-profile'

export const USER_TASK_SPECTATOR_FIRST_QUERY_KEY = 'getUserTaskSpectatorFirst'

export const useGetUserTaskSpectatorFirst = (
  userTaskSpectatorDefaultId: number,
  enabled = true,
) => {
  const { user } = useGetMyProfile()
  const { day } = useGetDates()

  const { data, isLoading, refetch } = useQuery({
    queryKey: [
      USER_TASK_SPECTATOR_FIRST_QUERY_KEY,
      { userTaskSpectatorDefaultId, userId: user?.id, dateTask: day },
    ],
    enabled,
    queryFn: () => {
      return userTaskSpectatorService.getFirst({
        userTaskSpectatorDefaultId,
        userId: user?.id,
        dateTaskInitial: day,
        dateTaskFinal: day,
        typeFilterDateTask: 'equal',
      })
    },
  })

  return {
    userTaskSpectator: data?.data,
    isLoading: isLoading,
    refetch,
  }
}
